import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../../../../pages/apps/lists/contacts/_subs/payment-info/payment-info.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from '../../../../../core/services/payment.service';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-payment-data',
  templateUrl: './payment-data.component.html',
  styleUrls: ['./payment-data.component.scss'],
})
export class PaymentDataComponent implements OnInit, OnDestroy {
  form: FormGroup;
  title: string;
  paymentDataComponent: Subscription;

  constructor(
    public dialogRef: MatDialogRef<PaymentDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      firstInsertion:
        this.data.paymentMethod === 'UA'
          ? ['', Validators.compose([Validators.required, Validators.pattern('^([0-9]){17}$')])]
          : ['', Validators.compose([Validators.required, Validators.pattern('^([0-9]){16}$')])],
      secondInsertion:
        this.data.paymentMethod === 'UA'
          ? [
              '',
              Validators.compose([Validators.required, Validators.pattern('^([0-9 a-z A-Z]){9}$')]),
            ]
          : [
              '',
              Validators.compose([
                Validators.required,
                Validators.pattern('^(0[1-9]|1[012])([2][01])([2-9])([0-9])$'),
              ]),
            ],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  get firstInsertion() {
    return this.form.get('firstInsertion');
  }

  get secondInsertion() {
    return this.form.get('secondInsertion');
  }

  onSubmitClick() {
    const controls = this.form.controls;
    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.paymentDataComponent = this.paymentService
      .saveAccountMethod({
        user_credit_card:
          this.data.paymentMethod === 'UC' ? this.form.controls.firstInsertion.value : '',
        credit_card_exp_date:
          this.data.paymentMethod === 'UC' ? this.form.controls.secondInsertion.value : '',
        user_aba: this.data.paymentMethod === 'UA' ? this.form.controls.secondInsertion.value : '',
        user_account:
          this.data.paymentMethod === 'UA' ? this.form.controls.firstInsertion.value : '',
        first_name: this.data.contact.first_name,
        payment_type: this.data.paymentMethod,
        contact_id: this.data.contact.id,
      })
      .subscribe(
        (res) => {
          this.layoutUtilsService.showActionNotification(
            res['ErrorMessage'] === '' ? 'Payment Method Saved' : res['ErrorMessage'],
            MessageType.Read,
            3000,
            false,
            false,
          );
          this.dialogRef.close();
        },
        (err) => {
          this.layoutUtilsService.showActionNotification(
            err.error.errors[0].details,
            MessageType.Read,
            3000,
            false,
            false,
          );
          this.dialogRef.close();
        },
      );
  }

  getErrorMessage(controlName: string, validationType: string) {
    if (controlName === 'firstInsertion' && this.data.paymentMethod === 'UC') {
      switch (validationType) {
        case 'required':
          return this.form.get(controlName)?.hasError('required') ? 'field required' : '';
        case 'pattern':
          return this.form.get(controlName)?.hasError('pattern') ? 'must be 16 number exactly' : '';
      }
      switch (validationType) {
        case 'required':
          return this.form.get(controlName)?.hasError('required') ? 'field required' : '';
        case 'pattern':
          return this.form.get(controlName)?.hasError('pattern') ? 'must be 17 number exactly' : '';
      }
    }
    if (controlName === 'secondInsertion' && this.data.paymentMethod === 'UA') {
      switch (validationType) {
        case 'required':
          return this.form.get(controlName)?.hasError('required') ? 'field required' : '';
        case 'pattern':
          return this.form.get(controlName)?.hasError('pattern')
            ? 'must be 9 character exactly '
            : '';
      }
    }
    switch (validationType) {
      case 'required':
        return this.form.get(controlName)?.hasError('required') ? 'field required' : '';
      case 'pattern':
        return this.form.get(controlName)?.hasError('pattern') ? 'Invalid Exp date' : '';
    }
  }

  ngOnDestroy() {
    this.paymentDataComponent?.unsubscribe();
  }
}
